<template>
	<div class="content">
		<div class="menu-right">
			<div class="title">
				<span>公司简介</span>
			</div>
			<div class="inner" v-for="(item,index) in clauseList" :key="index">
				<div class="sm-title">{{item.title}}</div>
				<p v-for="(item1,index1) in item.list">{{item1.text}}</p>
			</div>
		</div>
	</div>
</template>

<script>
export default{
	data(){
		return {
			clauseList: [
				{
					title: '',
					list: [
						{text: '派派回收（https://www.wpiaoall.com）由深圳网飘科技有限公司运营，环保型二手电子产品回收平台，成立于2016年，注册地位于深圳市龙华新区大浪街道华荣路163号荣泰大厦1112。'},
						{text: '经营范围包括网络产品、通讯产品、电子产品、数码产品及配件的研发与销售；经营电子商务；国内贸易（不含专营、专卖、专控商品）；经营进出口业务；通讯设备、智能硬件终端产品的租赁。数码电子产品上门维修。'},
						{text: '派派回收是深圳网飘科技有限公司旗下的专业的手机回收平台，对手机产品进行回收再利用，环保生产，扶持回收企业，检测，维修，售后服务整合为一体的科技企业。专注手机，手表，平板，笔记本，无人机等数码产品的回收服务。为用户提供专业质保，顺丰包邮，隐私清除，24小时内打款等服务。'},
						{text: '产品服务包括：'},
						{text: '派派回收采用互联网+大数据运营模式打通线上线下回收网络，为用户提供专业质保，顺丰包邮，隐私清除，极速打款等一站式回收服务。'},
						{text: '【顺丰包邮】顺丰上门取件，高效便捷；'},
						{text: '【专业质检】专业质检人员一对一服务；'},
						{text: '【隐私保护】保护隐私，清除数据；'},
						{text: '【闪电打款】质检通过后2小时内打款；'}
					]
				}
			]
		}
	}
}
</script>

<style scoped>
.menu-right .title span{
	font-size: 24px;
	border-bottom: 3px solid #FF6700;
	padding-bottom: 4px;
}

.menu-right p{
	font-size: 16px;
	line-height: 30px;
	color: #282828;
	margin-top: 20px;
}

.menu-right .inner .sm-title{
	margin-top: 20px;
	color: #FF6800;
}
</style>
